// extracted by mini-css-extract-plugin
export default {"screenInfo":"_1oIG1ERKkb3bIOBFiJ7bPc bg-black--translucent borderRadius-m boxShadow-outside--black--pellucid c-white fontSize-s padding-xs verticalAlign-middle whiteSpace-nowrap"};